
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/home-battery/PowerOcean/EcoFlow-App",
      function () {
        return require("private-next-pages/solutions/home-battery/PowerOcean/EcoFlow-App/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/home-battery/PowerOcean/EcoFlow-App"])
      });
    }
  